import { Interface } from 'ethers/lib/utils.js';
import abi from '../abi';
import type { MarketIdentifiers } from '$lib/types/market';
import { MARKET_ADDRESES } from '../addresses';
import { SYNTHETIX_PERP_ADVANCED_CONNECTOR } from './constants';

export const submitPairOrderRequest = (
	marketIdentifier: MarketIdentifiers,
	sizeDelta: string,
	priceImpact: string,
	expiry: string,
	firstPairA: string,
	firstPairB: string,
	secondPairA: string,
	secondPairB: string
) => {
	const advancedOrderInterface = new Interface(abi.scWalletSynthetixPerpV2AdvancedOrder);

	const request = {
		sizeDelta: sizeDelta,
		priceImpactDelta: priceImpact,
		expiry: expiry,
		firstPairA: firstPairA,
		firstPairB: firstPairB,
		secondPairA: secondPairA,
		secondPairB: secondPairB
	};

	const submitPairOrderEncodedData = advancedOrderInterface.encodeFunctionData('submitPairOrder', [
		MARKET_ADDRESES[marketIdentifier],
		request
	]);

	return {
		_target: SYNTHETIX_PERP_ADVANCED_CONNECTOR,
		_callData: submitPairOrderEncodedData
	};
};

export const submitFullOrderRequest = (
	marketIdentifier: MarketIdentifiers,
	sizeDelta: string,
	priceImpact: string,
	expiry: string,
	priceA: string,
	priceB: string,
	firstPairA: string,
	firstPairB: string,
	secondPairA: string,
	secondPairB: string
) => {
	const advancedOrderInterface = new Interface(abi.scWalletSynthetixPerpV2AdvancedOrder);

	const request = {
		sizeDelta: sizeDelta,
		priceImpactDelta: priceImpact,
		expiry: expiry,
		priceA: priceA,
		priceB: priceB,
		firstPairA: firstPairA,
		firstPairB: firstPairB,
		secondPairA: secondPairA,
		secondPairB: secondPairB
	};

	const submitFullOrderEncodedData = advancedOrderInterface.encodeFunctionData('submitFullOrder', [
		MARKET_ADDRESES[marketIdentifier],
		request
	]);

	return {
		_target: SYNTHETIX_PERP_ADVANCED_CONNECTOR,
		_callData: submitFullOrderEncodedData
	};
};

export const cancelPairOrderRequest = (orderId: string) => {
	const advancedOrderInterface = new Interface(abi.scWalletSynthetixPerpV2AdvancedOrder);

	const cancelPairOrderEncodedData = advancedOrderInterface.encodeFunctionData('cancelPairOrder', [
		orderId
	]);

	return {
		_target: SYNTHETIX_PERP_ADVANCED_CONNECTOR,
		_callData: cancelPairOrderEncodedData
	};
};

export const cancelFullOrderRequest = (orderId: string) => {
	const advancedOrderInterface = new Interface(abi.scWalletSynthetixPerpV2AdvancedOrder);

	const cancelFullOrderEncodedData = advancedOrderInterface.encodeFunctionData('cancelFullOrder', [
		orderId
	]);

	return {
		_target: SYNTHETIX_PERP_ADVANCED_CONNECTOR,
		_callData: cancelFullOrderEncodedData
	};
};
